

import DragItem from './DragItem'

class DragContainerModel {

    constructor() {
        this.dragItemList = []
        this.selectedStyle = null
    }

    addDragItem = (dragItem) => {
        dragItem.dragIndex = this.dragItemList.length
        this.dragItemList.push(dragItem)
    }

    getAsJson = () => {
        let obj = {}
        obj.dragItemList = []
        for (let i = 0; i < this.dragItemList.length; i++) {
            obj.dragItemList.push(this.dragItemList[i].getAsJson())
        }
        obj.selectedStyle = this.selectedStyle
        return obj
    }

    initFromJson = (obj) => {
        for (let i = 0; i < obj.dragItemList.length; i++) {
            let dragItem = new DragItem()
            dragItem.initFromJson(obj.dragItemList[i])
            this.dragItemList.push(dragItem)
        }
        this.selectedStyle = obj.selectedStyle
        this.styleModification()
    }

    styleModification = () => {

        this.selectedStyle[0].style.border = "solid 0px black"
        this.selectedStyle[0].style.paddingTop = "0px"
    }

    getReportAsJson = () => {
        let obj = {}


        return this.getAsJson()
    }

    initReportFromJson = (obj) => {
        this.initFromJson(obj)
    }

    initFromJsonTest4You = (obj) => {
        let dragContainerModel = JSON.parse(obj)
        for (var key of Object.keys(dragContainerModel)) {
            let dragItem = new DragItem();
            dragItem.dragIndex = parseInt(key) - 1
            dragItem.dragTxt = dragContainerModel[key]
            dragContainerModel[key] = dragContainerModel[key].replaceAll("###", "")
            dragItem.dragItemType = this.isImageURL(dragContainerModel[key]) ? dragItem.IMG_TYPE : dragItem.TXT_TYPE
            if (dragItem.dragItemType == dragItem.TXT_TYPE)
                dragItem.dragViewTxt = dragContainerModel[key]
            else
                dragItem.dragImgUrl = dragContainerModel[key]
            this.dragItemList.push(dragItem)
        }
    }
    initFromJsonTest4YouForCompareConnect = (obj) => {

        let question = obj.question
        let questionObj = JSON.parse(question);
        let list = questionObj.list
        let columnB = list.columnB
        this.dragItemList = []

        for (var key of Object.keys(columnB)) {
            let dragItem = new DragItem()
            dragItem.dragIndex = parseInt(key) - 1
            dragItem.dragTxt = columnB[key].replace('###', '')
            this.dragItemList.push(dragItem)
        }
    }
    isImageURL(url) {
        return (url.toLowerCase().match(/\.(jpeg|jpg|gif|png)$/) != null);
    }
}

export default DragContainerModel